/**
 * Overview page filter helpers.
 *
 * Keeps the date-range selector shareable via URL query params.
 *
 * @copyright 2025 Glimbr Pty Ltd
 * @version 2026-04-22-v1
 */

export type OverviewDateRange = '7d' | '30d' | '90d';

export const OVERVIEW_DATE_RANGES: readonly OverviewDateRange[] = ['7d', '30d', '90d'];
export const DEFAULT_OVERVIEW_DATE_RANGE: OverviewDateRange = '30d';

export function isOverviewDateRange(value: string | null): value is OverviewDateRange {
    return value === '7d' || value === '30d' || value === '90d';
}

export function parseOverviewDateRange(value: string | null): OverviewDateRange {
    return isOverviewDateRange(value) ? value : DEFAULT_OVERVIEW_DATE_RANGE;
}

export function overviewDateRangeDays(range: OverviewDateRange) {
    return Number(range.replace('d', ''));
}
